import { formatFullDate } from "@taskfortress/core"
import React, { useMemo } from "react"
import { Box } from "./Box"
import { Icon } from "./Icons"
import { Pressable } from "./Pressable"
import { Text } from "./Text"

interface HeaderBarProps {
  date: Date
  onDatePress: () => void
  onFilterPress: () => void
}

export const HeaderBar: React.FC<HeaderBarProps> = ({
  date,
  onDatePress,
  onFilterPress,
}) => {
  // Memoize formatted date computation
  const formattedDate = useMemo(() => formatFullDate(date), [date])

  // Memoize hitSlop objects to prevent recreation on every render
  const hitSlop = useMemo(
    () => ({ top: 10, bottom: 10, left: 10, right: 10 }),
    [],
  )

  return (
    <Box className="flex-row items-center justify-between bg-background-0 border-b border-outline-200 py-3 px-4">
      <Pressable onPress={onDatePress} hitSlop={hitSlop} className="p-2">
        <Icon name="calendar" className="h-6 w-6 text-typography-800" />
      </Pressable>

      <Text className="text-typography-800 font-semibold">{formattedDate}</Text>

      <Pressable onPress={onFilterPress} hitSlop={hitSlop} className="p-2">
        <Icon name="filter" className="h-6 w-6 text-typography-800" />
      </Pressable>
    </Box>
  )
}
